
<template>
  <div class="upload-file">
    <slot :uploadFile="openDialog">
      <v-btn fab dark class="indigo" @click.native="openDialog">
        <v-icon dark>add</v-icon>
      </v-btn>
    </slot>
  </div>
</template>

<script>
  export default {
    name: 'upload-file',
    props: {
      accept: {
        type: String,
        default: '*'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: true
      },
      directory: {
        type: Boolean,
        default: false
      },
      parentId: {
        type: Number,
        default: null
      },
      isReport: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {}
    },
    methods: {
      openDialog () {
        const attributes = {
          accept: this.accept,
          multiple: this.multiple,
          webkitdirectory: this.directory,
          mozdirectory: this.directory,
          disabled: this.disabled,
          style: 'display:none',
          type: 'file'
        }

        const input = document.createElement('INPUT')
        for (let key in attributes) {
          if (typeof attributes[key] === 'boolean') {
            if (attributes[key]) {
              input.setAttribute(key, key)
            }
          } else {
            input.setAttribute(key, attributes[key])
          }
        }
        input.onchange = event => {
          this.onFileChange(event)
          document.body.removeChild(input)
        }

        document.body.appendChild(input)
        input.click()
      },
      onFileChange ($event) {
        const files = $event.target.files || $event.dataTransfer.files
        this.sendFile(files)
      },
      sendFile (files) {
        this.$emit('uploadStart')
        const parentID = this.parentId || this.$store.state.file.record.id_file

        const usedStorageDialog = (() => {
          let executed = false
          return () => {
            if (!executed) {
              executed = true
              this.$store.dispatch('dialog/showDialog', {
                title: 'No more space left',
                body: require('~/components/common/dialog/types/DialogNoMoreSpace.vue').default,
                persistent: true,
                width: 480,
                actions: {
                  cancel: 'Close'
                }
              })
            }
          }
        })()

        this.$upload({
          reload: !this.isReport,
          files: files,
          params: {
            parent_id: parentID,
            is_report: this.isReport
          },
          successCallback: {
            $store: this.$store,
            idFile: parentID
          }
        }).then(() => {
          this.$store.dispatch('session/storageUpdated')
          this.$emit('success')
        }).catch(error => {
          if (error.status === 402) {
            usedStorageDialog()
          } else {
            this.$store.dispatch('feedback/addSnack', {text: error.message})
          }
          this.$emit('fail')
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  input {
    width: 0;
    height: 0;
    margin: 0;
    padding: 0;
  }

  .upload-file {
    display: inline-block;
  }
</style>

<style lang="css" >
  .menu__content .upload-file {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/UploadFile.vue